import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { PageHero, DemoBadge, Img } from "@/components/common";
import useTitle from "@/lib/useTitle";
import { fmtDay } from "@/lib/time";

export default function Semana() {
  useTitle("Semana da Saúde Mental");
  const { data } = useSite();
  const ed = data.edition;
  const [day, setDay] = useState("todos");
  const fair = ed.fair_date;
  const events = day === "todos" ? data.events : data.events.filter((e) => !e.date_label && e.date_start <= fair && fair <= e.date_end);
  const tile = (on) => `rounded-2xl p-3 sm:p-4 text-left transition-colors ${on ? "bg-[var(--ink)] text-white" : "bg-white border hover:bg-slate-50"}`;
  return (
    <>
      <PageHero eyebrow="Outubro a Dezembro de 2026" title="Semana da Saúde Mental" tone="#1d4ed8" image="/img/lisbon.jpg">Cinema, conversas, podcast, escolas, oficinas e iniciativas culturais e comunitárias. A Feira de Saúde e Bem-Estar é o ponto alto da Semana.</PageHero>
      <div className="container-x py-12">
        <div className="grid grid-cols-2 sm:grid-cols-6 gap-2 mb-12" role="tablist" aria-label="Dias da Semana">
          <button role="tab" aria-selected={day === fair} onClick={() => setDay(fair)} className={tile(day === fair)} data-testid={`week-day-${fair}`}>
            <p className="eyebrow text-[0.65rem]">{fmtDay(fair).split(",")[0].replace("-feira", "")}</p>
            <p className="font-display text-3xl font-black">{fair.slice(8)}</p>
            <p className="text-xs mt-1 opacity-80">Feira</p>
          </button>
          <button role="tab" aria-selected={day === "todos"} onClick={() => setDay("todos")} className={tile(day === "todos")} data-testid="week-day-todos">
            <p className="eyebrow text-[0.65rem]">Todos</p>
            <p className="font-display text-xl sm:text-2xl font-black leading-tight">os dias</p>
            <p className="text-xs mt-1 opacity-80">{data.events.length} iniciativas</p>
          </button>
        </div>
        <ul className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {events.map((e, i) => (
            <li key={e.id} className={i === 0 ? "md:col-span-2" : ""}>
              <Link to={`/semana/${e.slug}`} className="group relative block h-full min-h-[280px] rounded-3xl overflow-hidden bg-[var(--ink)] text-white" data-testid={`week-event-${e.slug}`}>
                <Img src={e.image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-55 group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
                <div className="relative h-full flex flex-col justify-end p-6">
                  <p className="eyebrow text-[var(--sun)]">{e.date_label || (e.date_start === e.date_end ? fmtDay(e.date_start, false) : `${e.date_start.slice(8)} a ${fmtDay(e.date_end, false)}`)}</p>
                  <h2 className="font-display text-2xl sm:text-3xl font-extrabold mt-2 flex items-start gap-2">{e.title}<ArrowUpRight className="h-6 w-6 shrink-0 opacity-0 group-hover:opacity-100 transition-opacity" aria-hidden /></h2>
                  <p className="text-sm text-white/85 mt-2 line-clamp-2">{e.summary}</p>
                  <DemoBadge show={e.demo} label="Em desenvolvimento" className="mt-3 self-start" />
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}
